const Backbone = require('backbone');
const SocialBarView = require('views/store/common/social/social_bar');

module.exports = Backbone.View.extend({
	el: '.js-article',
	initialize: function() {
		this.childViews.social = new SocialBarView();

		const $prodTileFinishPopovers = this.$('.js-finish-popover'),
			$emailSubmissionForm = this.$('.js-email-submission-form');
		if ($prodTileFinishPopovers.length) {
			$prodTileFinishPopovers.popover();
		}

		if ($emailSubmissionForm.length) {
			import(/* webpackChunkName: "emailSubmissionForm" */ 'views/store/common/construct/email_submission_form').then(
				this._initializeEmailSubmissionForm.bind(this)
			);
		}
	},
	_initializeEmailSubmissionForm: function(EmailSubmissionFormView) {
		this.childViews.emailSubmissionForm = new EmailSubmissionFormView();
	}
});
